import React from "react";
import PropTypes from "prop-types";
import SideMenu from "../components/SideMenu";

const AppMenu = (props) => {
  let { menutoggle, menu } = props;
  const toggleState = !!menutoggle; // Casts to boolean

  return <SideMenu menu={menu} collapsed={toggleState}></SideMenu>;
};

// AppMenu.propTypes = {
//   menutoggle: PropTypes.bool,
//   menu: PropTypes.array.isRequired
// };
// Set default prop to ensure it is boolean if not provided
AppMenu.defaultProps = {
  menutoggle: false, // Default to false if not provided
};

// PropTypes validation
AppMenu.propTypes = {
  menutoggle: (props, propName, componentName) => {
    if (typeof props[propName] !== "boolean") {
      return new Error(
        `Invalid prop \`${propName}\` supplied to \`${componentName}\`. Expected a boolean.`
      );
    }
  },
  menu: PropTypes.array.isRequired,
};
export default AppMenu;